import store from '@/user/store'
import ErrorService from './error.service'

export class CloudAxiosIntercepter {
  /**
   * @alias module:@apis/common/create-axios
   * @method setLoaderStatus
   * @param {boolean} showLoader 표시되고 있는 로더가 있는지 확인
   * @param {string} status 로더 상태
   * @returns {promise}
   */
  static setLoaderStatus = (showLoader, status) => {
    if (!showLoader) return
    store.dispatch(`LoaderStore/${status}`)
  }

  /**
   * @alias module:@apis/common/create-axios
   * @method requestHandler
   * @param {AxiosRequestConfig} request Axios Request
   * @returns {AxiosRequestConfig} request
   */
  static requestHandler = (request) => {
    this.setLoaderStatus(request.showLoader, 'pending')
    return request
  }

  /**
   * @alias module:@apis/common/create-axios
   * @method responseHandler
   * @param {AxiosResponse} request Axios Response
   * @returns {{AxiosResponse<T>}} response
   */
  static responseHandler = (response) => {
    this.setLoaderStatus(response.config.showLoader, 'done')
    return response
  }

  /**
   * @alias module:@apis/common/create-axios
   * @method errorHandler
   * @param {AxiosError} error Axios Error
   * @returns {{AxiosError<T>}} Error
   */
  static defaultErrorHandler = (error, callback = () => {}) => {
    this.setLoaderStatus(error.config.showLoader, 'done')
    store.getters['LoaderStore/loading'] && store.dispatch('LoaderStore/init')
    callback()
    return Promise.reject(error)
  }

  static useErrorServiceHandelr = (error) => {
    return this.defaultErrorHandler(error, () => ErrorService.onError(error))
  }
}
